import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { registerServiceWorker } from "./pwa";
import "./styles/index.scss";

// Installation et reprise hors ligne : seulement sur un site construit — en
// développement, un service worker mettrait le rechargement à chaud en défaut.
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
